import React, { useState } from 'react'
import WmModals from "../../modals/Wm.Modals";
import { Col } from 'react-bootstrap'
import Wmbutton from '../../ui-components/wm-button/Wm.button';
import Required from '../../Components/required/Required';


function Hobbies({title,onHandleHobby}) {
    const [hobbyTitle,setHobbbyTitle] = useState(title || '')
    const [openHobbyModal, setOpenHobbyModal] = useState(false)
    return (
        <>
            <Col md={12} className="my-8">
                <div className="mb-3">
                    <Wmbutton className="px-4 rounded" label="Add Hobbies" type="button" color="primary" onClick={() => setOpenHobbyModal(true)} />
                </div>
            </Col>
            <WmModals show={openHobbyModal} onHide={() => setOpenHobbyModal(false)} size="lg" className="">
                <div className="modal--head border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="modal-title manpro font-bold text-2xl">Hobbies and interests</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--body border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="wm_form_group flex flex-col">
                                    <label className="wm_form_label"> Title <Required /></label>
                                    <input type="text" name="institute" required className="wm_form_input border-bottom border-gray-300" value={hobbyTitle} onChange={(e) => setHobbbyTitle(e.target.value)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--foot py-3">
                    <div className="container-fluid">
                        <div className="row justify-end px-3">
                            <div className="space-x-3">
                                <Wmbutton className="px-4 rounded" label="Add" type="button" color="primary" onClick={() => {onHandleHobby(hobbyTitle);setHobbbyTitle('');setOpenHobbyModal(false)}}/>
                                <Wmbutton className="px-4 rounded" label="Cancel" bordered type="button" color="primary-border" onClick={() => setOpenHobbyModal(false)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </WmModals>
        </>
    )
}

export default Hobbies
